import axios from 'axios';
import { UploadFileMutations } from '../graphql/upload-file.mutations';
import { apolloClient } from '@/apollo';
import { IUploadFileUrl } from '@/types/upload-file-url';

export class UploadFileService {
  static async getUploadFilesUrls(
    documentId: string,
    filenames: string[]
  ): Promise<IUploadFileUrl[]> {
    const {
      data: { getUploadFilesUrls },
    } = await apolloClient.mutate({
      mutation: UploadFileMutations.getUploadFilesUrlsMutation,
      variables: { documentId, filenames },
    });
    return getUploadFilesUrls;
  }

  static async uploadFiles(uploadFileUrls: IUploadFileUrl[], files: File[]): Promise<void> {
    await Promise.all(
      uploadFileUrls.map(async ({ uploadUrl }: IUploadFileUrl, index: number) => {
        return axios.put(uploadUrl, files[index]);
      })
    );
  }

  static async uploadFilesDone(
    documentId: string,
    index: number,
    uniqueFilenames: string[]
  ): Promise<boolean> {
    const {
      data: { uploadFilesDone },
    } = await apolloClient.mutate({
      mutation: UploadFileMutations.uploadFilesDoneMutation,
      variables: { documentId, index, uniqueFilenames },
    });
    return uploadFilesDone;
  }
}
